import { XeroNoteService } from '@common/lib/api';
import * as xeronote from './types';

const actions = {
  async [xeronote.FETCH_DEVICE_LIST](context, params) {
    let { data } = await XeroNoteService.getDevices(params);

    if (params.manufacturerId == 'ETC') {
      data.content = data.content.filter(device => {
        return !device.manufacturer_id.includes(['SAMSUNG', 'APPLE', 'LG']);
      });
    }

    context.commit(xeronote.SET_DEVICE_LIST, data);

    return data;
  },
  async [xeronote.FETCH_DIV_MONTH](context, params) {
    const { data } = await XeroNoteService.getDivMonth(params);
    context.commit(xeronote.SET_DIV_MONTH, data);

    return data;
  },
  async [xeronote.FETCH_PLANS](context, params) {
    const { data } = await XeroNoteService.getPlans(params);
    context.commit(xeronote.SET_PLANS, data);

    return data;
  },
  async [xeronote.FETCH_TELECOM_LIST](context, params) {
    const { data } = await XeroNoteService.getTelecoms(params);
    context.commit(xeronote.SET_TELECOM_LIST, data);

    return data;
  },
  async [xeronote.FETCH_NICKNAME](context, params) {
    const { data } = await XeroNoteService.getNickname(params);
    context.commit(xeronote.SET_NICKNAME, data);

    return data;
  },
};

export default actions;
